// Module
var code = "<template>\n  <require from=\"./service-kpi-antifouling\"></require>\n\n  <service-kpi-antifouling></service-kpi-antifouling>\n</template>\n";
// Exports
export default code;